import {Component, inject, OnInit} from '@angular/core';
import {FiltersSidebarComponent} from './components/filters-sidebar/filters-sidebar.component';
import {ResultsHeaderComponent} from './components/results-header/results-header.component';
import {ResultsTableComponent} from './components/results-table/results-table.component';
import {ResultsFooterComponent} from './components/results-footer/results-footer.component';
import {ResultTableService} from './services/result-table.service';
import {ResultsStore} from '../../shared/store/results.store';
import {AppStore} from '../../shared/store/app.store';

@Component({
  selector: 'app-results',
  standalone: true,
  imports: [FiltersSidebarComponent, ResultsHeaderComponent, ResultsTableComponent, ResultsFooterComponent],
  templateUrl: './results.component.html',
  styleUrl: './results.component.css'
})
export class ResultsComponent implements OnInit {
  resultTableService = inject(ResultTableService);
  resultsStore = inject(ResultsStore);
  private appStore = inject(AppStore);

  ngOnInit() {
    this.resultTableService.clearFilters();
    this.resultsStore.setQuantity(this.appStore.cart().repair_order?.default_order_quantity || 4)

    if (this.resultsStore.results().some(({is_preferred}) => is_preferred)) {
      this.resultTableService.updateFilter('brand', [...new Set(this.resultsStore.results().filter(({is_preferred}) => is_preferred).map(({brand}) => brand))]);
    }
  }
}
